<div class="linked-checkpoints" [nbSpinner]="loading()" nbSpinnerStatus="primary">
  <div class="toolbar">
    <div class="count">Verknüpfungen mit Prüfpunkten: {{ count() }}</div>
    <div class="search">
      <input nbInput
             fullWidth
             type="text"
             placeholder="Suche"
             [ngModel]="filterText()"
             (ngModelChange)="filterText.set($event)">
    </div>
    <button class="expand-toggle" nbButton ghost status="primary" size="small" (click)="toggleExpandAll()">
      {{ allExpanded() ? 'Zuklappen' : 'Aufklappen' }}
    </button>
  </div>

  @if (error(); as err) {
    <nb-alert status="danger" [closable]="false">{{ err }}</nb-alert>
  }

  <nb-accordion class="checkpoint-list" [multi]="true">
    @for (link of filteredCheckpoints(); track link.checkpoint.id) {
      <nb-accordion-item [expanded]="isExpanded(link.checkpoint.id)"
                         (collapsedChange)="onCollapsedChange(link.checkpoint.id, $event)">
        <nb-accordion-item-header>
          <div class="checkpoint-title">
            <div class="checkpoint-number">
              <span>{{ link.checkpoint.checkpointGroupNumber }}</span>
              <span>.</span>
              <span>{{ link.checkpoint.number }}</span>
            </div>
            <span class="checkpoint-name">{{ link.checkpoint.name }}</span>
          </div>
          @if (hasSelectionInCheckpoint(link)) {
            <div class="actions">
              <div class="actions-absolute" (click)="$event.stopPropagation()">
                <button nbButton
                        status="danger"
                        size="small"
                        (click)="unlinkSelected(link)">
                  Verknüpfung aufheben
                </button>
              </div>
            </div>
          }
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <table class="assessment-table">
            <thead>
              <tr>
                <th class="col-select">
                  <nb-checkbox [checked]="isAllSelectedInCheckpoint(link)"
                               [indeterminate]="isPartiallySelectedInCheckpoint(link)"
                               [disabled]="!isEditing()"
                               (checkedChange)="toggleAllInCheckpoint(link)"></nb-checkbox>
                </th>
                <th class="col-text">Feststellung</th>
                <th class="col-action">Maßnahme</th>
                <th class="col-deadline">Frist</th>
                <th class="col-arrow"></th>
              </tr>
            </thead>
            <tbody>
              @for (preset of link.assessmentPresets; track preset.id) {
                <tr>
                  <td class="col-select">
                    <nb-checkbox [checked]="isPresetSelected(preset.id)"
                                 [disabled]="!isEditing()"
                                 (checkedChange)="togglePresetSelection(preset.id)"></nb-checkbox>
                  </td>
                  <td class="col-text">{{ preset.text }}</td>
                  <td class="col-action">
                    @if (preset.action) {
                      {{ preset.action.name }}
                    }
                  </td>
                  <td class="col-deadline">{{ preset.checkInterval | deadlineTranslation }}</td>
                  <td class="col-arrow">
                    <button nbButton
                            ghost
                            size="small"
                            nbTooltip="Zum Prüfpunkt"
                            (click)="navigateToCheckpoint(link.checkpoint.id)">
                      <nb-icon pack="eva" icon="arrow-forward-outline"></nb-icon>
                    </button>
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="5" class="empty">Keine Feststellungen verknüpft.</td>
                </tr>
              }
            </tbody>
          </table>
        </nb-accordion-item-body>
      </nb-accordion-item>
    } @empty {
      <div class="empty-state">
        @if (!loading() && !error()) {
          Keine Prüfpunkte oder Feststellungen sind mit diesem TGA Bauplan verknüpft.
        }
      </div>
    }
  </nb-accordion>
</div>
